import React, { useEffect, useRef, useState } from 'react';
import { CONTENT, TABS } from './StorageUnitSizeContent';
import './StorageUnitSizeModal.scss';

export default function StorageUnitSizeModal() {
	const [active, setActive] = useState(TABS[0]);
	const wrapperRef = useRef(null);
	const tabRefs = useRef({});

	const data = CONTENT[active];

	useEffect(() => {
		if (!wrapperRef.current || !tabRefs.current[active]) return;

		const wrapperRect = wrapperRef.current.getBoundingClientRect();
		const btnRect = tabRefs.current[active].getBoundingClientRect();
		const centerX = btnRect.left + btnRect.width / 4 - wrapperRect.left;

		wrapperRef.current.style.setProperty('--triangle-x', `${centerX}px`);
	}, [active]);

	return (
		<div
			className="unit-size-guide"
			ref={wrapperRef}
		>
			<div className="unit-size-guide__tabs">
				{TABS.map((tab) => (
					<button
						key={tab}
						ref={(el) => {
							if (el) tabRefs.current[tab] = el;
						}}
						className={`unit-size-guide__tab ${
							active === tab ? 'is-active' : ''
						}`}
						onClick={() => setActive(tab)}
					>
						{tab}
					</button>
				))}
			</div>

			<div className="unit-size-guide__triangle" />
			<div className="unit-size-guide__content">
				<h2 className="size_title">{data?.title}</h2>
				{data &&
					Object.entries(data)
						.filter(([key]) => key !== 'title')
						.map(([key, value]) => (
							<div
								className="size_row"
								key={key}
							>
								<strong className="size_label">{key}</strong>
								<span className="size_value">{value}</span>
							</div>
						))}
			</div>
		</div>
	);
}
